"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.LoaderCircular = void 0;
require("./LoaderCircular.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * LoaderCircular component
 *
 * @method
 * @param { LoaderCircularProps } props
 * @returns LoaderCircular
 */

const LoaderCircular = props => {
  const {
    color = defaultProps.color,
    ...other
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-LoaderCircular', {
    [`pal-c-LoaderCircular--${color}`]: color
  });
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassName
  }, other));
};

/**
 * Property type definitions
 * @typedef LoaderCircularProps
 * @type {object}
 * @property {string} color - Changes the color of the Circular spinner only.
 */
exports.LoaderCircular = LoaderCircular;
const propTypes = exports.propTypes = {
  /**
   * Changes the color of the Circular spinner only. Has no effect on Linear
   * - **primary:** Orange color
   * - **secondary:** Default black color
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} color - set the default value for color
 */
const defaultProps = exports.defaultProps = {
  color: 'primary'
};
LoaderCircular.propTypes = propTypes;
var _default = exports.default = LoaderCircular;